import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-65917187"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sort-filter-separator" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_popover = _resolveComponent("ion-popover")!

  return (_openBlock(), _createBlock(_component_ion_popover, {
    "is-open": _ctx.isOpen,
    translucent: true,
    event: _ctx.domEvent,
    "css-class": "popover-deviations-filter",
    onDidDismiss: _ctx.close
  }, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, { scrollY: "false" }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_list, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_item, {
                lines: "none",
                detail: "false",
                class: "header-item"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_label, { class: "header-text" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Sort by")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_button, {
                    class: "header-action-button",
                    fill: "clear",
                    onClick: _ctx.toggleSortingDirection
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.sortDirection === 'ascending' ? 'Ascending' : 'Descending'), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_icon, {
                        icon: _ctx.sortDirectionIcon,
                        color: "primary",
                        slot: "end"
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortItems, (item, index) => {
                return (_openBlock(), _createBlock(_component_ion_item, {
                  onClick: ($event: any) => (_ctx.selectSortBy(item.key)),
                  key: item.key,
                  lines: index === _ctx.sortItems.length - 1 ? 'none' : 'full',
                  detail: "false",
                  button: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, {
                      class: _normalizeClass({ 'selected': item.selected })
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["class"]),
                    (item.selected)
                      ? (_openBlock(), _createBlock(_component_ion_icon, {
                          key: 0,
                          icon: _ctx.checkmarkIcon,
                          color: "primary",
                          slot: "end"
                        }, null, 8, ["icon"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1032, ["onClick", "lines"]))
              }), 128))
            ]),
            _: 1
          }),
          _hoisted_1,
          _createVNode(_component_ion_list, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_item, {
                lines: "none",
                detail: "false",
                class: "header-item"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_label, { class: "header-text" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Filter by")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_button, {
                    class: "header-action-button",
                    fill: "clear",
                    onClick: _ctx.resetFilter
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Clear")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_icon, {
                        icon: _ctx.resetFilterIcon,
                        color: "primary",
                        slot: "end"
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterItems, (item, index) => {
                return (_openBlock(), _createBlock(_component_ion_item, {
                  onClick: ($event: any) => (_ctx.selectFilter(item.key)),
                  key: item.key,
                  lines: index === _ctx.filterItems.length - 1 ? 'none' : 'full',
                  detail: "false",
                  button: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, {
                      class: _normalizeClass({ 'selected': item.selected })
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["class"]),
                    (item.selected)
                      ? (_openBlock(), _createBlock(_component_ion_icon, {
                          key: 0,
                          icon: _ctx.checkmarkIcon,
                          color: "primary",
                          slot: "end"
                        }, null, 8, ["icon"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1032, ["onClick", "lines"]))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["is-open", "event", "onDidDismiss"]))
}